import { useAuth } from '../components/Providers/AuthProvider';
import { usePage } from '../components/Providers/PageProvider';

export function useIsPageOwner() {
  const auth = useAuth();
  const { owner } = usePage();
  return auth?.getAccessToken()?.guid === owner.id;
}
